import { findObjectById } from "@/utils/global";
import { useMemo } from "react";

const useHandleMainBannersData = ({ context, categoryID }) => {

  const handleMainBannersData = useMemo(() => {
    const selectedData =
      Array.isArray(context?.appData?.categoryData?.children_data) &&
      context?.appData?.categoryData?.children_data?.length
        ? findObjectById(
          context?.appData?.categoryData?.children_data,
          categoryID
        )
        : null;

    if (selectedData) {
      return [
        {
          img: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/${selectedData?.image_one}`,
          url: selectedData?.url_key,
          title: selectedData?.name,
          type: "category",
        },
        {
          img: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/${selectedData?.image_two}`,
          url: selectedData?.url_key,
          title: selectedData?.name,
          type: "category",
        },
        {
          img: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/${selectedData?.image_three}`,
          url: selectedData?.url_key,
          title: selectedData?.name,
          type: "category",
        },
        {
          img: `${process.env.NEXT_PUBLIC_IMG_BASEURL}/${selectedData?.image_four}`,
          url: selectedData?.url_key,
          title: selectedData?.name,
          type: "category",
        },
      ];
    }

    return [];
  }, [categoryID, context?.appData?.categoryData?.children_data]);

  return {
    handleMainBannersData
  };
};

export default useHandleMainBannersData;
